import { SeriesSelector } from 'components/series-selector';
import {
  VolumeDisplayModeRadio,
  type VolumeDisplayMode,
} from 'components/well-page-content';
import { MineralType } from 'types/minerals';
import style from './chart-actions.module.scss';
import classNames from 'classnames';
import { Toggle } from 'components/toggle/toggle';
import { useMemo } from 'react';
import { XAxisSwitcher } from 'components/well-page-content/decline-curve-analysis/x-axis-switcher';
import { XAxisType } from 'components/well-page-content/types';

interface ChartActionsProps {
  selectedLegend: Array<MineralType | 'GOR' | 'WOR' | 'WGR' | 'CGR'>;
  handleLegendClick: (legend: MineralType) => void;
  enableTypeCurve: boolean;
  showTypeCurve: boolean;
  setShowTypeCurve: (show: boolean) => void;
  chartType: 'monthly' | 'logarithmic' | 'cumulative' | 'ratio';
  xAxisType: XAxisType;
  setXAxisType: (xAxisType: XAxisType) => void;
  /** Monthly volumes or daily rates, for the monthly and log charts. */
  volumeDisplayMode: VolumeDisplayMode;
  onVolumeDisplayModeChange: (mode: VolumeDisplayMode) => void;
}

export const ChartActions = ({
  selectedLegend,
  handleLegendClick,
  showTypeCurve,
  setShowTypeCurve,
  enableTypeCurve,
  chartType,
  xAxisType,
  setXAxisType,
  volumeDisplayMode,
  onVolumeDisplayModeChange,
}: ChartActionsProps) => {
  const availableSeries = useMemo(() => {
    if (chartType === 'ratio') {
      return ['GOR', 'WOR', 'WGR', 'CGR'];
    }
    return ['oil', 'gas', 'water'];
  }, [chartType]);
  return (
    <div className={style.chartActionsContainer}>
      <SeriesSelector
        allItems={availableSeries}
        selectedItems={selectedLegend}
        onSelectionChange={handleLegendClick as any}
        testId="decline-curve-workspace-legend-container"
        className={style.seriesSelector}
      />

      <div className={style.rightActionContainer}>
        <XAxisSwitcher
          className={style.xAxisSwitcher}
          chartType={chartType}
          value={xAxisType}
          onChange={setXAxisType}
        />
        <div
          className={classNames(style.typeCurveToggleContainer, {
            [style.hidden]: !enableTypeCurve,
          })}
        >
          <Toggle
            isActive={showTypeCurve}
            handleToggle={() => setShowTypeCurve(!showTypeCurve)}
            label="Display Type Curve"
          />
        </div>
        <VolumeDisplayModeRadio
          value={volumeDisplayMode}
          onChange={onVolumeDisplayModeChange}
          idPrefix="dca-workspace"
        />
      </div>
    </div>
  );
};
